import Axios from 'axios';
import header from './auth/header';

const API_URL =  process.env.API_URL + '/api/v1/';
const API_URL_V3 = process.env.API_URL + '/api/v3/'

class Product {
  index(params) {
    let url = new URLSearchParams(params).toString();
    return Axios.get(API_URL + `product-list?${url}`);
  }

  show(product) {
    return Axios.get(API_URL + `product/${product}`);
  }

  funderShow(product) {
    return Axios.get(API_URL + `funder-product/${product}`);
  }

  mitraShow(product) {
    return Axios.get(API_URL + `mitra-product/${product}`, { headers: header() });
  }

  orderName() {
    return Axios.get(API_URL + 'product-ordername');
  }

  store(data) {
    return Axios.post(API_URL + 'add-product', data, { headers: header() });
  }

  update(data) {
    return Axios.put(API_URL + 'update-product', data, { headers: header() });
  }

  delete(id) {
    return Axios.delete(API_URL + `delete-product/${id}`, { headers: header() });
  }

  productOnMitra(mitra) {
    return Axios.get(API_URL + `product-on-mitra/${mitra}`, { headers: header() });
  }
  
  lendingOnMitra(mitra) {
    return Axios.get(API_URL + `lending-on-mitra/${mitra}`, { headers: header() });
  }

  productPengajuan() {
    return Axios.get(API_URL + 'product-pengajuan', { headers: header() });
  }

  productClosing() {
    return Axios.get(API_URL + 'product-closing', { headers: header() });
  }

  productFilter(filter, id) {
    return Axios.get(API_URL + `product-list/filter/${filter}/${id}`);
  }

  productSorting(sort, mode) {
    return Axios.get(API_URL + `product-list/sorting/${sort}/${mode}`);
  }

  productSearch(search) {
    return Axios.get(API_URL + `product-list/search/${search}`);
  }

  changePublishStatus(data) {
    return Axios.patch(API_URL + 'change-publish-status', data,  { headers: header() })
  }

  getIsFillMitraData() {
    return Axios.get(API_URL + `getIsFillMitraData`, { headers: header() });
  }
  
  installmentSimulation(productId, downPayment, tenurePeriod) {
    return Axios.get(`${API_URL_V3}product-lending/funder/${productId}/simulation/installment`, {
      params: {
        down_payment: downPayment,
        tenure_period: tenurePeriod
      }
    });
  }

  IndexDeposito(){
    return Axios.get(API_URL_V3 + `product/funder`);
  }

  showDeposito(id){
    return Axios.get(API_URL_V3 + `product/funder/${id}?with=mitra.mitra_profile,subCategory,category,akad`);
  }
}

export default new Product();



// WEBPACK FOOTER //
// ./src/api/produk.js